import { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'utils/axios';

import ContractsContext from 'contexts/ContractsContext';
import MainCard from 'ui-component/cards/MainCard';

import { IconButton, Stack, Box, Typography, Skeleton, CircularProgress } from '@mui/material';
import { IconWritingSign } from '@tabler/icons';
import { useTheme } from '@mui/material/styles';

const Contracts = () => {
    const [openingContractId, setOpeningContractId] = useState(null);

    const { contracts, loading, loadContracts } = useContext(ContractsContext);

    const navigate = useNavigate();
    const { state } = useLocation();
    const theme = useTheme();

    const openContractToSign = async (contract) => {
        setOpeningContractId(contract.id);

        const { data } = await axios.post(
            `/api/contracts/createsession?documentId=${contract.id}&recipientEmail=${contract.recipientEmail}`
        );

        navigate(`/contracts/${data.id}`, { state });
        setOpeningContractId(null);
    };

    useEffect(() => loadContracts(), []);

    return (
        <MainCard title="Contracts">
            <Stack spacing={2}>
                {loading ? (
                    <Skeleton variant="rounded" sx={{ maxWidth: '500px' }} height={50} />
                ) : (
                    <>
                        {contracts?.map((c) => (
                            <Box
                                key={c.id}
                                sx={{
                                    padding: 0.5,
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 2,
                                    background: '#fafafa',
                                    transition: 'box-shadow 0.2s',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                                    maxWidth: '500px'
                                }}
                            >
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                    justifyContent="space-between"
                                    sx={{ marginLeft: 1 }}
                                >
                                    <Typography variant="subtitle1">{c.name}</Typography>
                                    <IconButton
                                        color="primary"
                                        disabled={openingContractId === c.id}
                                        onClick={() => openContractToSign(c)}
                                        sx={{ float: 'right', borderRadius: 2 }}
                                    >
                                        {openingContractId === c.id && (
                                            <CircularProgress
                                                size={24}
                                                sx={{
                                                    color: theme.palette.primary.main,
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    marginTop: '-12px',
                                                    marginLeft: '-12px'
                                                }}
                                            />
                                        )}
                                        <IconWritingSign />
                                    </IconButton>
                                </Stack>
                            </Box>
                        ))}
                        {!contracts.length && (
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography>No contracts available to sign</Typography>
                            </Box>
                        )}
                    </>
                )}
            </Stack>
        </MainCard>
    );
};

export default Contracts;
